import { render, staticRenderFns } from "./IconChar.vue?vue&type=template&id=5da75c9a&scoped=true"
import script from "./IconChar.vue?vue&type=script&lang=js"
export * from "./IconChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da75c9a",
  null
  
)

export default component.exports